import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import HomeIcon from '@material-ui/icons/Home';
import CodeIcon from '@material-ui/icons/Code';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'react-admin';

const Welcome = () => (
    <Card>
        <CardContent>
            <Typography variant="headline" component="h2">
                Tervetuloa
            </Typography>
            <Typography component="p">
                wss-portaaliin
            </Typography>
        </CardContent>
        <CardActions style={{ justifyContent: 'flex-end' }}>
            <Button>
                <HomeIcon style={{ paddingRight: '0.5em' }} />
                "foobar"
            </Button>
            <Button>
                <CodeIcon style={{ paddingRight: '0.5em' }} />
                "xyzzy"
            </Button>
        </CardActions>
    </Card>
);

const enhance = compose(
    translate
);

export default enhance(Welcome);
